import { DYNAMIC_ICONIC_SPRITE_URL } from '../../constants';

export const DEFAULT_WAAS_BASE_API_URL = 'https://app.dynamicauth.com';
export const DEFAULT_WAAS_BASE_MPC_RELAY_API_URL =
  'https://relay.dynamicauth.com';

export const DYNAMIC_WAAS_METADATA = {
  displayName: 'Dynamic WaaS',
  icon: `${DYNAMIC_ICONIC_SPRITE_URL}#dynamicwaas`,
  normalizedWalletName: 'dynamicwaas',
};
